import type { ReactNode } from 'react';
import { forwardRef } from 'react';
import {
	GovFormFile,
	type GovFormFileProps,
} from '@gov-design-system-ce/react/gov-form';

interface FormFileProps extends Omit<
	GovFormFileProps,
	'disabled' | 'expanded' | 'required' | 'multiple' | 'invalid'
> {
	children: ReactNode;

	isDisabled?: boolean;
	isExpanded?: boolean;
	isRequired?: boolean;
	isMultiple?: boolean;
	isInvalid?: boolean;
}

export const FormFile = forwardRef<HTMLInputElement, FormFileProps>(
	(
		{
			children,
			isDisabled,
			isExpanded,
			isRequired,
			isMultiple,
			isInvalid,
			...props
		},
		ref
	) => (
		<GovFormFile
			ref={ref}
			{...props}
			disabled={isDisabled}
			expanded={isExpanded}
			required={isRequired}
			multiple={isMultiple}
			invalid={isInvalid}>
			{children}
		</GovFormFile>
	)
);

FormFile.displayName = 'FormFile';
